import { SettingConst } from '@faire/web-api--source/types';

/**
 * Narrowing search suggestions filters experiment
 */
export const NARROWING_SEARCH_SUGGESTIONS_FILTER_XP_250509 =
  'NARROWING_SEARCH_SUGGESTIONS_FILTER_XP_250509' as SettingConst<
    'NARROWING_SEARCH_SUGGESTIONS_FILTER_XP_250509',
    boolean,
    'RETAILER' | 'RETAILER_IOS' | 'RETAILER_ANDROID'
  >;
